module.exports = __webpack_public_path__ + "assets/img/74@3x.d28b1d98.png";